module.exports = __webpack_public_path__ + "img/门禁控制器.1e5516cc.jpg";